import { DatePipe, registerLocaleData } from "@angular/common";
import { HttpClient, HTTP_INTERCEPTORS } from "@angular/common/http";
import localeSv from "@angular/common/locales/sv";
import {
  LOCALE_ID,
  NgModule,
  APP_INITIALIZER,
} from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalInterceptor,
  MsalBroadcastService,
  MsalGuard,
  MsalModule,
  MsalService,
  MsalRedirectComponent,
} from "@azure/msal-angular";
import {
  MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory,
} from "../assets/config/msal-config";
import { AuthCallbackComponent } from "./auth-callback/auth-callback.component";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { EventModule } from "./home/event-container/event.module";
import { FiltersModule } from "./home/filters/filters.module";
import { HomeComponent } from "./home/home.component";
import { LineMapModule } from "./home/line-map/line-map.module";
import { NavMenuComponent } from "./nav-menu/nav-menu.component";
import { NotificationItemComponent } from "./nav-menu/user-menu/notification-item/notification-item.component";
import { UserMenuComponent } from "./nav-menu/user-menu/user-menu.component";
import { NotAuthorizedComponent } from "./not-authorized/not-authorized.component";
import { RedirectPageComponent } from "./redirect-page/redirect-page.component";
import { SharedModule } from "./shared/shared.module";
import { RetryInterceptor } from "./shared/interceptors/retry-interceptor";
import { DateInterceptor } from "./shared/interceptors/date-interceptor";
import { CategoryFilterComponent } from "./home/announcement-filter/category-filter/category-filter.component";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
registerLocaleData(localeSv, "sv");
registerLocaleData(localeSv, "sv-SE");

// AoT (Ahead-of-Time) compiler requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export function MSALInitializerFactory(msalService: MsalService) {
  return async () => {
    await msalService.initialize();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    AuthCallbackComponent,
    NavMenuComponent,
    HomeComponent,
    UserMenuComponent,
    NotificationItemComponent,
    NotAuthorizedComponent,
    RedirectPageComponent,
    CategoryFilterComponent
  ],
  imports: [
    AppRoutingModule,
    SharedModule,
    FiltersModule,
    LineMapModule,
    EventModule,
    BrowserModule,
    MsalModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
  })
   // MultiSelectModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: "sv-SE" },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RetryInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DateInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    DatePipe,
    {
      provide: APP_INITIALIZER,
      useFactory: MSALInitializerFactory,
      deps: [MsalService],
      multi: true
    }
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule { }
